import React, { useEffect, useState } from "react";

import {
  ErrorMessage,
  InputDiv,
  InputDiv1,
  InputFieldDiv,
} from "../../style/Table.style";
import { Box, MenuItem, TextField, Zoom } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { ThemButton } from "../../Login/Login.style";
import { SyncLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Percent } from "@mui/icons-material";
const AddThana = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [division, setDivision] = useState([]);
  const [divisionId, setDivisionId] = useState("");
  const [district, setDistrict] = useState([]);
  const [districtId, setDistrictId] = useState("");

  useEffect(() => {
    const getDivision = async () => {
      const resDivision = await fetch(
        `${process.env.REACT_APP_API_URL}/api/divisionList`
      );
      const resDiv = await resDivision.json();
      setDivision(await resDiv);
    };
    getDivision();
  }, []);

  const handleDivision = (event) => {
    const getDivisionId = parseInt(event.target.value,10);
    setDivisionId(getDivisionId);
  };

  useEffect(() => {
    if (divisionId) {
      const getDistrict = async () => {
        const resDistrict = await fetch(
          `${process.env.REACT_APP_API_URL}/api/districtList/${divisionId}`
        );
        const resDis = await resDistrict.json();
        setDistrict(await resDis);
      };
      getDistrict();
    }
  }, [divisionId]);

  const handleDistrict = (event) => {
    const getDistrictId = (event.target.value);
    setDistrictId(getDistrictId);
  };
  const distict_id1= parseInt(divisionId+ districtId, 10);

  const schema = yup.object().shape({});
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    const formData = new FormData();
    const upazila_id = distict_id1 + data?.thana_code;

 
    formData.append("distict_id", distict_id1);
    formData.append("thana_code", data.thana_code);
    formData.append("thana_name", data.thana_name);
    formData.append("upazila_id", upazila_id);

    fetch(
      `${process.env.REACT_APP_API_URL}/api/createThana`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data) {
          toast.success("Thana add successful!.", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error("Thana not added!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
      dispatch(handleAddClose());
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box p="20px">
          <TextField
            fullWidth
            size="small"
            id="outlined-select-currency"
            select
            label="Division"
            onChange={(e) => handleDivision(e)}
          >
            {division.map((division) => (
              <MenuItem key={Math.random()} value={division.divsion_id}>
                {division.divsion_nm}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            fullWidth
            size="small"
            id="outlined-select-currency"
            select
            label="District"
            onChange={(e) => handleDistrict(e)}
          >
            {district.map((district, index) => (
              <MenuItem key={Math.random()} value={district.dzila_code}>
                {district.dzila_name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            size="small"
            name="thana_code"
            fullWidth
            label="Thana Code*"
            variant="outlined"
            {...register("thana_code", { required: true })}
          />
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            size="small"
            name="thana_name"
            fullWidth
            label="Police Station Name*"
            variant="outlined"
            {...register("thana_name", { required: true })}
          />
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            select
            name="astatus_fg"
            size="small"
            fullWidth
            label="Active Status*"
            variant="outlined"
            {...register("astatus_fg")}
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Inactive</MenuItem>
          </TextField>
          {errors?.active_fg && (
            <ErrorMessage>{errors.active_fg.message}</ErrorMessage>
          )}
        </Box>
        <Box
          marginTop="20px"
          style={{
            margin: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {isLoading ? (
            <ThemButton style={{}} type="submit">
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton
              style={
                {
                  // width: "30%",
                }
              }
              type="submit"
            >
              Add Thana
            </ThemButton>
          )}
        </Box>

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </form>
    </>
  );
};
export default AddThana;
